export default __webpack_public_path__ + "static/media/SystemLightClockLight.02443e54.png";